export default "__VITE_ASSET__5ccNj3u5__"